import { Box, CircularProgress, Divider, IconButton, styled } from "@mui/material";
import { useContext, useState } from "react";
import { MyTrainingsViewContext } from "context/myTrainings/MyTrainingsViewContext";
import { MyTrainingsViewContextProvider } from "context/myTrainings/MyTrainingsViewContextProvider";
import { MobileHomeHeaderComponent } from "components/Mobile/HomeHeaderComponent";
import { MobileHomeStatisticsComponent } from "components/Mobile/HomeStatisticsComponent";
import { MobileHomeLessonComponent } from "components/Mobile/HomeLessonComponent";
import { MobileMenuComponent } from "components/Mobile/MenuComponent";
import theme from "theme/theme";
import { StyledLogo } from "components/NavbarComponent/NavbarComponent.styles";
import MenuIcon from '@mui/icons-material/Menu';

const LoadingBox = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
});

const PageBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  position: "relative",
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(3),
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(5),
  gap: theme.spacing(2),
  overflowY: "auto",
  minHeight: "100vh",
  backgroundColor: theme.palette.common.white,
}));

const MenuButtonPositioner = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: theme.spacing(2),
  right: theme.spacing(2),
}));

const CircularMenuButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  "&:hover": {
    backgroundColor: theme.palette.primary.dark,
  },
}));

const MobileHomePageContent = () => {
  const { user, trainingStatistics } = useContext(MyTrainingsViewContext);
  const [menuOpen, setMenuOpen] = useState(false);

  if (!user) {
    return (
      <LoadingBox>
        <CircularProgress />
      </LoadingBox>
    );
  }

  return (
    <PageBox>
      <StyledLogo src={"ISSVR_Logo.png"} alt="logo" $marginRight={theme.spacing(4)} />
      <MenuButtonPositioner>
        <CircularMenuButton onClick={() => setMenuOpen(true)}>
          <MenuIcon />
        </CircularMenuButton>
      </MenuButtonPositioner>
      <MobileMenuComponent open={menuOpen} onClose={() => setMenuOpen(false)} />
      <MobileHomeHeaderComponent />
      <MobileHomeStatisticsComponent />
      <Divider />
      {trainingStatistics && (
        <>
          <MobileHomeLessonComponent />
        </>
      )}
    </PageBox>
  );
};

export const MobileHomePage = () => (
  <MyTrainingsViewContextProvider>
    <MobileHomePageContent />
  </MyTrainingsViewContextProvider>
);
